// eslint-disable-next-line
export default new (class StaffModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.type = data.section || "";
    model.field_name = data.field_name || null;
    model.list = data.staff || [];

    return model;
  }

  // รูปทรงว่างที่ปลอดภัย ใช้เมื่อ API ล้มเหลวหรือไม่มีข้อมูล
  // หน้าเพจอ่าน .list ได้เสมอโดยไม่ throw
  empty() {
    return { id: 0, type: "", field_name: null, list: [] };
  }
})();
